function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m5 39h54v14h-54z",
  fill: "#8892a0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.5 62c-.828 0-1.5-.672-1.5-1.5v-23c0-.828.672-1.5 1.5-1.5.828 0 1.5.672 1.5 1.5v23c0 .828-.672 1.5-1.5 1.5z",
  fill: "#4d5d7a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m60.5 62c.828 0 1.5-.672 1.5-1.5v-23c0-.828-.672-1.5-1.5-1.5-.828 0-1.5.672-1.5 1.5v23c0 .828.672 1.5 1.5 1.5z",
  fill: "#4d5d7a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f5b953"
}, /*#__PURE__*/React.createElement("path", {
  d: "m36 50h18c1.105 0 2-.895 2-2v-2h-22v2c0 1.105.895 2 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38.716 27h12.568c.987 0 1.827.72 1.977 1.696l1.739 11.304v1c0 1.105-.895 2-2 2h-16c-1.105 0-2-.895-2-2v-1l1.739-11.304c.15-.976.99-1.696 1.977-1.696z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 50h-18c-1.105 0-2-.895-2-2v-2h22v2c0 1.105-.895 2-2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.284 27h-12.568c-.987 0-1.827.72-1.977 1.696l-1.739 11.304v1c0 1.105.895 2 2 2h16c1.105 0 2-.895 2-2v-1l-1.739-11.304c-.15-.976-.99-1.696-1.977-1.696z"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 10,
  fill: "#2d4d83",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 10,
  fill: "#4472b2",
  r: 6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m14 30h10v2h-10z",
  fill: "#f9d18b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m40 30h10v2h-10z",
  fill: "#f9d18b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m36 11h-4c-.553 0-1-.448-1-1v-6h2v5h3z",
  fill: "#fff"
})));

var SvgLounge = function SvgLounge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLounge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lounge.46535db6.svg";
export { ForwardRef as ReactComponent };